module.exports = __webpack_public_path__ + "img/Desktop-up.e337a1bc.jpg";